<template>
  <LeftPanel :title="'Лог'" @close="panelClose" :show="panelShow">
    <p>service: <b style="color: darkgreen">{{this.panelData.service}}</b></p>
    <p>ip: {{this.panelData.ip}}</p>
    <p>env: {{this.panelData.env}}</p>
    <br>
    <hr/>
    <br>
    <p>date: {{this.panelData.date}}</p>
    <p>level: {{this.panelData.level}}</p>
    <br>
    <hr/>
    <br>
    <p>message: {{this.panelData.message}}</p>
    <p>context: {{this.panelData.context}}</p>
    <p>hash: {{this.panelData.hash}}</p>
    <br>
    <hr/>
    <br>
    <pre>{{this.panelData}}</pre>
  </LeftPanel>

  <DataTable
      :columns="columns"
      :data="logData"
      @row-dblclick="showLog"></DataTable>
</template>

<script>
import DataTable from "@/components/DataTable.vue";
import LeftPanel from "@/components/panel/LeftPanel.vue";

export default {
  name: 'LogsPage',
  components: {DataTable, LeftPanel},
  data() {
    return {
      panelShow: false,
      panelData: null,
      more: false,
      logData: [
        {
          row: 1,
          row2: 1,
        },
        {
          row: 1,
          row2: 1,
        }
      ],
      columns: [
        {
          name: "date",
          title: "Дата",
        },
        {
          name: "ip",
          title: "ip",
        },
        {
          name: "service",
          title: "Сервис",
        },
        {
          name: "env",
          title: "Env",
        },
        {
          name: "level",
          title: "Уровень",
        },
        {
          name: "corID",
          title: "CorID",
        },
        {
          name: "message",
          title: "Сообщение",
        }
      ],
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    panelClose() {
      this.panelShow = false;
    },
    showLog(item) {
      this.panelData = item;
      this.panelShow = true;
      console.log(item);
    },
    loadData: function () {
      console.log("load logs")
      let c = this;
      c.logData = null;
      c.loading = true;
      c.error = false;
      this.axios.get('/api/log').then(function(response) {
        console.log(response.data);
        c.logData = response.data.data;
        c.more = response.data.more;
        c.loading = false;
      }).catch(function(err) {
        console.log(err.status);
        c.loading = false;
        c.error = true;
      });
    }
  }
}
</script>

<style scoped>

</style>